<template>
  <div>
    <h4>酒店房间</h4>
    <el-form
        v-for="(room, index) in rooms"
        :key="index"
        style="border-bottom: 1px solid #ccc"
        :class="{'first-room': index === 0}"
        :ref="'room_'+index"
    >
      <h5>房间{{ index + 1 }}</h5>
      <el-form-item label="房间名称">
        <el-input v-model="room.name"></el-input>
      </el-form-item>
      <el-form-item label="房间描述">
        <el-input v-model="room.desc"></el-input>
      </el-form-item>
      <el-form-item label="相关图片" prop="pictures">
        <image-uploader :key="index" :max-count="4" :value="room.pictures"/>
      </el-form-item>
      <el-button type="danger" @click="remove(index)" style="margin-bottom: 20px;">删除该房间</el-button>
    </el-form>
    <el-button type="primary" style="margin-top: 20px;" @click="add">
      增加一间
    </el-button>
  </div>
</template>
<script>
import {ElMessage} from 'element-plus'
import axios from '../../../request'
import ImageUploader from '../../../components/ImageUploader'

const roomItem = {
  name: '',
  desc: '',
  pictures: []
}

export default {
  props: ['rooms'],
  components: {ImageUploader},
  setup(props) {
    const remove = index => {
      props.rooms.splice(index, index + 1)
    }
    const add = () => {
      props.rooms.push({...JSON.parse(JSON.stringify(roomItem))})
    }

    const validateRooms = () => {
      if(props.rooms.every(({name}, index)=>{
        if(!name){
          ElMessage.error(`信息不全: 第${index + 1}个房间没填写名称`)
          return false
        }
        return true
      })){

      }else{
        return false
      }
    }

    const submitRooms = async ({id}) => {
      console.log(id)
      await axios.post(`/hotels/${id}/update_rooms`, {
        rooms: props.rooms.map(room=>({
          ...room,
          pictures: room.pictures.map((v)=>{
            if(v.response){
              return v.response.files[0].url
            }
            return v.url
          })
        }))
      })
      props.rooms.splice(0,0)
    }

    return {
      remove,
      add,
      validateRooms,
      submitRooms,
    }
  }
}
</script>
